import { settings, settingsCategories } from "./settings";
import { buffsHiddenHTML } from "../handlers/buffs/createBuffsToggler";
import { qtId } from "../utils/dom";
export const applySettings = () => {
    for (const category of settingsCategories) {
        for (const option of category.options) {
            if (!option.onChange)
                continue;
            if (option.type === "slider") {
                option.onChange(settings[option.id]);
            }
            else {
                option.onChange(settings[option.id]);
            }
        }
    }
    if (!settings.showBuffTimers) {
        const buffToggler = l(qtId("buffToggler"));
        if (buffToggler)
            buffToggler.innerHTML = buffsHiddenHTML;
    }
};
